<sim-basic-material-dialog
	(closeClicked)="close()"
	[headerIcon]="{fontSet: 'fad', fontIcon: 'fa-layer-plus'}"
	[headerText]="T.CREATE_DRAFT_EVENT_DIALOG_HEADER | translate"
>
	<ng-container dialogContent>
		<form>
			<!--NAME-->
			<mat-form-field color="accent">
				<mat-label>
					<mat-icon fontIcon="fa-signature" fontSet="fad" />
					{{ T.LABEL_NAME | translate }}
				</mat-label>
				<!--TODO SIMSOFT-9873 Readonly styling missing-->
				<input [formControl]="form.controls.name" matInput type="text" />
				<mat-error>{{ T.ERROR_REQUIRED | translate }}</mat-error>
			</mat-form-field>

			@if (AllActiveEventTypes.length > 1) {
				<mat-form-field color="accent">
					<mat-label>
						<mat-icon fontIcon="fa-ballot-check" fontSet="fad" />
						{{ T.CREATE_DRAFT_EVENT_DIALOG_SELECT_EVENT_TYPE | translate }}
					</mat-label>
					<mat-select [formControl]="form.controls.type">
						@for (eventType of AllActiveEventTypes; track eventType) {
							<mat-option [value]="eventType">
								@switch (eventType) {
									@case (EventType.Simulation) {
										<mat-icon fontIcon="fa-users-class" fontSet="fad" matIconSuffix inline />
									}
									@case (EventType.Exam) {
										<mat-icon fontIcon="fa-chalkboard-teacher" fontSet="fad" matIconSuffix inline />
									}
									@case (EventType.PeerPractice) {
										<mat-icon fontIcon="fa-user-friends" fontSet="fad" matIconSuffix inline />
									}
									@case (EventType.MultiRoomRecording) {
										<mat-icon fontIcon="fa-images-user" fontSet="fad" matIconSuffix inline />
									}
									@case (EventType.AutomaticRecording) {
										<mat-icon fontIcon="fa-clapperboard-play" fontSet="fad" matIconSuffix inline />
									}
								}
								{{ eventType | enumLabel: EnumLabel.EventType }}
							</mat-option>
						}
					</mat-select>
				</mat-form-field>
			}

			<!--DURATION-->
			<mat-form-field color="accent">
				<mat-label>
					<mat-icon fontIcon="fa-calendar-week" fontSet="fad" />
					{{ T.LABEL_DURATION | translate }}
				</mat-label>
				<mat-date-range-input [rangePicker]="picker">
					<input
						(focus)="picker.open()"
						[formControl]="form.controls.start"
						[placeholder]="T.EVENT_CREATION_SET_START_DATE_PLACEHOLDER | translate"
						matStartDate
					/>
					<input
						(focus)="picker.open()"
						[formControl]="form.controls.end"
						[placeholder]="T.EVENT_CREATION_SET_END_DATE_PLACEHOLDER | translate"
						matEndDate
					/>
				</mat-date-range-input>
				<mat-datepicker-toggle [for]="picker" matSuffix>
					<mat-icon color="accent" fontIcon="fa-calendar-day" fontSet="fas" matDatepickerToggleIcon />
				</mat-datepicker-toggle>
				<mat-date-range-picker #picker />
				<mat-error>
					{{ T.ERROR_REQUIRED | translate }}
				</mat-error>
			</mat-form-field>

			<button #formSubmit (click)="doSubmit()" hidden></button>
		</form>
	</ng-container>
	<ng-container actions>
		<sim-button
			(onClick)="formSubmit.click()"
			[appBusy]="promise()"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.BUTTON_SAVE"
			color="accent"
			variant="raised"
		/>
	</ng-container>
</sim-basic-material-dialog>
